import type {SenseAction} from 'src/action-creators/types';
import type {AllowedPhoneNumberResponseMap} from 'src/types/chat/allowed-phone-numbers';

import {RECEIVE} from 'src/action-creators/chat/allowed-phone-numbers';


export type State = {
  responses: AllowedPhoneNumberResponseMap;
};

const initialState = {
  responses: Object.freeze({}),
} as const;

export default function reduce(
  state: State | null | undefined = initialState,
  action: SenseAction,
): State {
  switch (action.type) {
    case RECEIVE: {
      return {
        ...state,
        responses: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.responses,
          ...action.payload,
        },
      };
    }
  }

  // @ts-expect-error - TS2322 - Type 'State | null' is not assignable to type 'State'.
  return state;
}
